import { render, staticRenderFns } from "./ADAcceptedSelector.vue?vue&type=template&id=97e31ed6&scoped=true&"
import script from "./ADAcceptedSelector.vue?vue&type=script&lang=js&"
export * from "./ADAcceptedSelector.vue?vue&type=script&lang=js&"
import style0 from "./ADAcceptedSelector.vue?vue&type=style&index=0&id=97e31ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e31ed6",
  null
  
)

export default component.exports